import React from 'react';
//import NavLinks from '../Navbar/NavLinks';
import { useConfig } from 'context/ConfigContext.js';





const NavBarFixed = ({ isHomePage = true }) => {
  const config = useConfig();
  if (!config) return null; // Guard clause

  const { appName } = config;

	if (isHomePage)
      return (
        <nav className="top-0 w-full z-30 bg-green-500 shadow-lg">
            <div className="container mx-auto px-4 h-full flex items-center justify-between">
			  <div><img className="ns-logo" src={`${process.env.PUBLIC_URL}/images/${appName}/app_logo_192.png`} alt={appName} width="192" height="74"/></div>
              <div className="space-x-4">
                {/* 修复了 href 警告，使用 "/#" 作为占位符链接 */}
				{/*<a href="#appIndexFeature" className="text-white hover:text-yellow-600">Features</a>*/}
                <a href="#appIndexContact" className="text-white hover:text-yellow-600">Contact Us</a>
              </div>
            </div>
        </nav>
      );
	  
	return (
        <nav className="top-0 w-full z-30 bg-green-500 shadow-lg">
            <div className="container mx-auto px-4 h-full flex items-center justify-between">
			  <div><img className="ns-logo" src={`${process.env.PUBLIC_URL}/images/${appName}/app_logo_192.png`} alt={appName} width="192" height="74"/></div>
              <div className="space-x-4">
                {/* 修复了 href 警告，使用 "/#" 作为占位符链接 */}
                <a href="/" className="text-white hover:text-yellow-600">Home</a>
              </div>
            </div>
        </nav>
      )
	
		
}


export default NavBarFixed;